module.exports = __webpack_public_path__ + "img/product_18.8c62f5b.webp";